'use client';

import { useEffect } from 'react';

import AOS from 'aos';
import 'aos/dist/aos.css';

/**
 * This component is used to initialize the AOS library.
 * It should only be used once per page, typically in the layout.
 *
 * As it utilizes the useEffect hook, it must be in a client component.
 */
export default function AosLoader() {
  useEffect(() => {
    AOS.init({
      once: true,
      disable: 'phone',
      duration: 600,
      easing: 'ease-out-sine',
    });
  });

  return null;
}
